module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 114.7 85.6"><path class="st0" d="M43.6 0h27.6v85.6H43.6V0zM0 0h27.6v85.6H0V0zm87.1 0h27.6v85.6H87.1V0z"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./src/assets/volume/ico-volume.svg
// module id = 436
// module chunks = 1